export const mainMenuNiveau2Props = () => ({
  navigationNode: {
    type: Object,
    required: false,
    default() {
      return {};
    }
  },
  isRecettes: {
    type: Boolean,
    required: false,
    default: false
  },
  coinDesMarquesIds: {
    type: Array,
    required: false,
    default: () => []
  },
  recettesPushZone: {
    type: Object,
    required: false,
    default: () => { }
  },
  arborescence: {
    type: Array,
    required: false,
    default: () => []
  }
})

export const useMainMenuNiveau2 = (props) => {
  const itemsANePasManquer = computed(() => {
    return props.navigationNode.attributes.children.data.filter(item => item.attributes.is_a_ne_pas_manquer);
  })
  const itemsNotANePasManquer = computed(() => {
    return props.navigationNode.attributes.children.data.filter(item => !item.attributes.is_a_ne_pas_manquer);
  })
  const hasMerch = computed(() => {
    return props.navigationNode.attributes.push_zones && props.navigationNode.attributes.push_zones.length > 0;
  })

  return {
    itemsANePasManquer,
    itemsNotANePasManquer,
    hasMerch
  }
}